import { ReactElement, ReactNode, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import ScrollLink from '@/lib/scroll'

import Container from './style'

export interface Props {
  href: string
  hash?: string
  children: ReactNode | string
  isSelected?: boolean
  style?: CSSProperties
  className?: string
  id?: string
  isExternal?: boolean
  onPress?: () => void
}

export interface State {
  isHovered: boolean
}

function MenuButton({
  id,
  children,
  className,
  style,
  href,
  hash,
  isSelected,
  isExternal,
  onPress,
}: Props): ReactElement {
  if (isExternal) {
    return (
      <a href={href} rel="noreferrer" target="_blank" onClick={onPress}>
        <Container
          id={id}
          className={`${className} ${isSelected ? 'selected' : 'not-selected'}`}
          style={style}
        >
          {children}
        </Container>
      </a>
    )
  }

  return (
    <ScrollLink
      url={{
        pathname: href,
        hash: hash,
      }}
    >
      <Container
        id={id}
        className={`${className} ${isSelected ? 'selected' : 'not-selected'}`}
        style={style}
        onClick={onPress}
      >
        {children}
      </Container>
    </ScrollLink>
  )
}

MenuButton.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

MenuButton.defaultProps = {
  className: '',
  isSelected: false,
  isExternal: false,
}

export default memo(MenuButton)
